module.exports = __webpack_public_path__ + "img/tax_ex1.6e96aa50.png";